{
  "language": {
    "thai": "ไทย",
    "english": "English",
    "switchLabel": "Change language",
    "thaiShort": "TH",
    "englishShort": "EN"
  },
  "all": "All",
  "recommendedPlan": "Recommended plan",
  "status": {
    "loading": "Loading"
  },
  "nav": {
    "home": "Home",
    "chat": "Inbox",
    "crm": "Customers (CRM)",
    "orders": "Orders",
    "products": "Products",
    "team": "Team",
    "settings": "Settings",
    "channels": "Channels",
    "billing": "Plan",
    "aiAssistant": "AI assistant",
    "delivery": "Delivery",
    "openMenu": "Open menu",
    "mainAria": "Main navigation",
    "groupWork": "Daily work",
    "groupSetup": "Shop setup",
    "attentionBadge_one": "{{count}} chat waiting for a person",
    "attentionBadge_other": "{{count}} chats waiting for a person",
    "attentionBadgeMore": "More than {{count}} chats waiting for a person"
  },
  "userMenu": {
    "fallbackName": "User",
    "changePassword": "Change password",
    "signOut": "Sign out",
    "accountOf": "{{name}}'s account"
  },
  "merchant": {
    "myStore": "My store",
    "switchStore": "Switch store"
  },
  "routeError": {
    "title": "Something went wrong while loading",
    "description": "Please try again",
    "retry": "Try again"
  },
  "cookies": {
    "dialogLabel": "Cookie settings",
    "title": "This site uses cookies",
    "body": "We use essential cookies to make the service work, and with your consent, cookies that help us analyse and improve it. Read more in our",
    "policyLink": "Cookie Policy",
    "essentialOnly": "Essential only",
    "acceptAll": "Accept all"
  },
  "subscription": {
    "loadFailed": "Unable to load plan information",
    "expired": "Expired",
    "daysLeft_one": "{{count}} day",
    "daysLeft_other": "{{count}} days",
    "freeEndsToday": "Your free plan ends today",
    "freeEndsIn": "Your free plan ends in {{duration}}",
    "buyPlan": "Buy a plan",
    "planExpired": "Your plan has expired. Subscribe to keep using Sight Order.",
    "pendingOrder": "You have an order awaiting payment",
    "viewOrders": "View orders",
    "planFree": "Free trial",
    "planPaid": "Paid plan",
    "statusActive": "Active",
    "statusPendingPayment": "Awaiting payment",
    "statusExpired": "Expired",
    "statusCancelled": "Cancelled",
    "noPlan": "No plan information yet",
    "startsAt": "Starts {{date}}",
    "endsAt": "Ends {{date}}",
    "remaining": "{{duration}} left",
    "totalSeats": "Total seats",
    "addonSeats": "Added to base plan",
    "seatCount_one": "{{count}} seat",
    "seatCount_other": "{{count}} seats",
    "addonSeatCount": "+{{count}}"
  },
  "document": {
    "title": "Sight Order — One inbox for Thai online sellers"
  }
}
